import React from 'react'
import styled from 'styled-components'
import Card2 from './Card2'
import { InnerLayout } from './Layout'
import check from '../../Assets/img/check.svg';
import checkDisabled from '../../Assets/img/check-disabled.svg';

const DetailCard = () => {
   return (
      <PaymentStyled id='pricing'>
         <InnerLayout>
            <div data-aos='fade-down-right'>
               <h3 className="small-heading">
               Building Tech. Building Community.
               </h3>
               <p className="c-para"> What Makes This Training Unique: It equips youth to design and use technology guided by justice, fairness, and inclusivity, empowering them to be ethical innovators who serve their communities and society at large. </p>
            </div>
            <div className='card-con'>
               <Card2
                  account={'Skills & Tools You’ll Gain'}
                  text={'Participants will analyze technology choices, consider community needs, design inclusively, and evaluate the impacts, risks, and benefits of technologies.'}
                  check={check}
                  checkDis={checkDisabled}
                  text1={'Ethical Analysis: Critically assess technologies for fairness, bias, and societal impact.'}
                  text2={'Justice-Centered Design: Apply principles of justice, inclusivity, and moderation to technology solutions.'}
                  text3={'Problem-Solving & Innovation: Design projects, apps, or campaigns that address real-world challenges ethically.'}
                  text4={'Collaboration: Work with peers to develop collective strategies and charters for just technology use.'}
                  text5={'Reflection & Critical Thinking: Build independent reasoning skills to resist bias, blind imitation, and unethical practices.'}
                  text6={'Community Engagement: Understand and address the needs of diverse communities through technology.'}
               />
            </div>
         </InnerLayout>
      </PaymentStyled>
   )
}

const PaymentStyled = styled.section`
 .card-con {
    display: flex; /* Use flexbox for centering */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding-top: 4rem; /* Adjust top padding */
    
    /* Optional: Use max-width to control the card's maximum size */
    max-width: 1200px; 
    margin: 0 auto;
    width: 100%; /* Ensure it takes full width of the container */
    
    /* Optional: If you want to increase the width of the cards themselves */
    .card2 {
      width: 100%; /* Adjust the width of individual cards */
      max-width: 100%; /* You can set a specific width like 80% or more */
    }

    @media screen and (max-width: 689px) {
      flex-direction: column; /* Stack content on mobile */
    }
  }

  p {
    text-align: center;
  }
`

export default DetailCard
